import TimelineIcon from "@mui/icons-material/Timeline";
import { TableCell } from "@mui/material";
import React from "react";
import {
  getBrokerOrdersTable,
  getStepGraph,
  getStepShekarChanceTable,
  refreshStepOrder,
} from "../../../Requests/stepRequests";
import useRequest from "../../../Hooks/useRequest";
import { toast } from "react-toastify";
import HuntStrategyChancesTable from "../../Order/HuntChances/HuntStrategyChancesTable";
import { WrappedTimeSeriesChart } from "../../../Components/Timeseries/WrappedTimeSeriesChart";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import RefreshIcon from "@mui/icons-material/Refresh";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { OrderStrategy } from "../../../Interfaces/orderInterfaces";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import BrokerOrdersTable from "../BrokerOrder/BrokerOrdersTable";
import SubOrdersTable from "../SubOrder/SubOrdersTable";
import { IStepTradeTableReport } from "../../../Interfaces/stepInterfaces";

const StepTradeTableAdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const StepTradeTableAdditionalCol: React.FC<{
  row: IStepTradeTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isChancesOpen, setIsChancesOpen] = React.useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] =
    React.useState(false);
  const refreshOrderRequest = useRequest(
    () => refreshStepOrder(row.sahraUserId),
    errorHandler
  );

  const orderGraphRequest = useRequest(
    () => getStepGraph(JSON.parse(row.getGraphStr)),
    errorHandler
  );

  const [isGraphModalOpen, setIsGraphModalOpen] = React.useState(false);

  React.useEffect(() => {
    if (refreshOrderRequest.response)
      toast.success(refreshOrderRequest.response.msg);
  }, [refreshOrderRequest.response]);

  function errorHandler(e: any) {
    let error: any;

    if (!e) error = "خطا در ارتباط با سرور";
    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    toast.error(error);
  }

  const refreshOrderClickHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    refreshOrderRequest.fetchData();
    onAction();
  };

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  const getGraphModalUI = () => {
    if (!orderGraphRequest.response) return null;
    return (
      <div className="chart-fill-modal">
        <WrappedTimeSeriesChart dataset={orderGraphRequest.response} className="h-full w-full" />
      </div>
    );
  };

  const getOrderGraphHandler = () => {
    orderGraphRequest.fetchData();
  };

  React.useEffect(() => {
    if (orderGraphRequest.response) setIsGraphModalOpen(true);
  }, [orderGraphRequest.response]);

  return (
    <>
      <TableCell>
        {refreshOrderRequest.loading ? <FullScreenLoading /> : null}
        <RefreshIcon
          fontSize="small"
          onClick={refreshOrderClickHandler}
          className="text-sky-800 cursor-pointer"
        />
      </TableCell>

      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal title="سفارشات"
            UI={
              <BrokerOrdersTable
                getData={getBrokerOrdersTable}
                stepOrderId={row.id}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isOpen ? (
          <Modal title="جزئیات"
            UI={<SubOrdersTable stepOrderId={row.id} />}
            onClose={() => setIsOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsOpen(true)}
          text="جزئیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isChancesOpen ? (
          <Modal title="شانس‌ها"
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getStepShekarChanceTable(
                    { stepOrderId: row.id },
                    offset,
                    pageSize
                  )
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        {row.orderStrategy === OrderStrategy.Hunt ? (
          <Button
            onClick={btnClickHandler}
            text="شانس ها"
            variant="contained"
            className="table-btn"
          />
        ) : null}
      </TableCell>
      <TableCell>
        {isGraphModalOpen ? (
          <Modal title="نمودار"
            onClose={() => setIsGraphModalOpen(false)}
            UI={getGraphModalUI()}
            fullScreen
          />
        ) : null}
        <Button
          onClick={getOrderGraphHandler}
          text={<TimelineIcon className="!text-base" />}
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const StepTradeTableAdditional: IAdditional<IStepTradeTableReport> = {
  getHeader: StepTradeTableAdditionalHeader,
  getRow: StepTradeTableAdditionalCol,
};
